import React from 'react';
import styled from 'styled-components';

import IconCross from '../IconCross';
import IconCookieBanner from '../IconCookieBanner';
import {
  Banner,
  BannerContainer,
  ButtonLink,
  BannerCopy,
  BannerCopyAside,
  BannerCopyInner,
  BannerActions,
  BannerAction,
} from '../';

const LevelsList = styled.ul`
  list-style: none;
  display: block;
`;

const LevelsListItem = styled.li`
  margin: 0;
  margin-top: 1em;
`;

const LevelsListItemLabel = styled.label`
  display: flex;
  cursor: pointer;
  > input {
    margin-right: 1em;
  }
`;

const LevelsListItemLabelCopy = styled.div`
  flex: 1:
`;

export default function CookiePreferences({
  optIn = {},
  containerWidth,
  onOptIn,
  onOptOut,
  levels = [],
  onDismiss,
  onViewCookiePolicy,
}) {
  return (
    <Banner aria-live="polite" role="alert" data-testid="cookie-prefs">
      <BannerContainer containerWidth={containerWidth} data-testid="cookie-prefs-container">
        <BannerCopy>
          <BannerCopyAside>
            <IconCookieBanner />
          </BannerCopyAside>
          <BannerCopyInner>
            <h2>manage preferences</h2>
            <p>
              choose which types of cookies and local storage usage you're happy with. opt out any time.
              <br />
              <ButtonLink role="button" onClick={onViewCookiePolicy}>
                view our cookie policy
              </ButtonLink>{' '}
              for extensive information on any data we ask your browser to keep for us.
            </p>

            <LevelsList>
              <LevelsListItem key="app-strictly-required">
                <LevelsListItemLabel>
                  <input type="checkbox" checked={true} disabled aria-labelledby="strictly-required-header" />
                  <LevelsListItemLabelCopy>
                    <h4 id="strictly-required-header">Strictly Required</h4>
                    <p>Only strictly required use of cookies and local storage for this app to function correctly.</p>
                  </LevelsListItemLabelCopy>
                </LevelsListItemLabel>
              </LevelsListItem>
              {levels.map(({ level, levelName, levelDescription }) => (
                <LevelsListItem key={level}>
                  <LevelsListItemLabel>
                    <input
                      aria-labelledby={`level-heading-${level}`}
                      type="checkbox"
                      checked={Boolean(optIn[level])}
                      onChange={e => {
                        if (e.target.checked) {
                          onOptIn(level);
                        } else {
                          onOptOut(level);
                        }
                      }}
                    />
                    <LevelsListItemLabelCopy>
                      <h4 id={`level-heading-${level}`}>{levelName}</h4>
                      <p>{levelDescription}</p>
                    </LevelsListItemLabelCopy>
                  </LevelsListItemLabel>
                </LevelsListItem>
              ))}
            </LevelsList>
          </BannerCopyInner>
        </BannerCopy>
        <BannerActions>
          <BannerAction onClick={onDismiss}>
            <IconCross />
            close
          </BannerAction>
        </BannerActions>
      </BannerContainer>
    </Banner>
  );
}
